import { Injectable } from '@angular/core';
import { State } from '@ngxs/store';
import { BrickLayoutType } from '../../../samwebDescription/samweb/dashboard/brickLayoutType';
import { BrickBehaviourStateState } from './brick-behaviour-state/brick-behaviour-state.state';
import { BrickDefinitionState } from './brick-definition/brick-definition.state';
import { BrickInstancesHelper } from './brick-instances/brick-instances.helper';
import { BrickInstancesState } from './brick-instances/brick-instances.state';
import { BrickSettingsState } from './brick-settings/brick-settings.state';

export interface BrickInstance {
   positionX: number;
   positionY: number;
   colWidth: number;
   rowHeight: number;
   brickDefinitionId: string;
   brickInstanceId: string;
   brickLayout: BrickLayoutType;
   updated: number;
}

// tslint:disable-next-line:no-empty-interface
export interface BrickWallStateModel {}

@State<BrickWallStateModel>({
   name: 'brickWall',
   defaults: {},
   children: [BrickSettingsState, BrickInstancesState, BrickInstancesHelper, BrickDefinitionState, BrickBehaviourStateState],
})
@Injectable()
export class BrickWallState {}
